import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleGroup, faBalanceScale, faHandHoldingHeart, faUsers } from '@fortawesome/free-solid-svg-icons';
import diversity from "../assets/diversity.jpg"
import ethic from "../assets/ethic.jpg"
import inclusion from "../assets/inclusion.jpg"
import social from "../assets/social.jpg"
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();
  const [activeValue, setActiveValue] = useState(0);

  const values = [
    {
      id: "01",
      title: t('values.diversity.title'),
      content: t('values.diversity.content'),
      icon: faPeopleGroup,
      imageSrc: diversity
    },
    {
      id: "02",
      title: t('values.inclusion.title'),
      content: t('values.inclusion.content'),
      icon: faUsers,
      imageSrc: inclusion
    },
    {
      id: "05",
      title: t('values.ethics.title'),
      content: t('values.ethics.content'),
      icon: faBalanceScale,
      imageSrc: ethic
    },
    {
      id: "06",
      title: t('values.social.title'),
      content: t('values.social.content'),
      icon: faHandHoldingHeart,
      imageSrc: social
    },
  ];

  
  return (
    <section className="aped-values-section">
      <div className="aped-values-content-wrapper">
        <h2 className="aped-values-title">{t('values.title')}</h2>
        <div className="aped-values-container">
          <div className="aped-values-sidebar">
            {values.map((value, index) => (
              <button
                key={value.id}
                className={`aped-value-button ${activeValue === index ? "active" : ""}`}
                onClick={() => setActiveValue(index)}
              >
                <FontAwesomeIcon icon={value.icon} className="aped-value-icon" />
                <span className="aped-value-title">{value.title}</span>
              </button>
            ))}
          </div>
          <div className="aped-value-content">
            <h3>
              <FontAwesomeIcon icon={values[activeValue].icon} />
              {values[activeValue].title}
            </h3>
            <p>{values[activeValue].content}</p>
            <img src={values[activeValue].imageSrc} alt={values[activeValue].title} className="aped-value-image" />
          </div>
        </div>
      </div>
      <style jsx>{`
        .aped-values-section {
          padding: 2rem 1rem;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        }

        .aped-values-content-wrapper {
          max-width: 1200px;
          margin: 0 auto;
        }

        .aped-values-title {
          font-size: 1.75rem;
          color: #1b1f3a;
          margin-bottom: 1.5rem;
          text-align: center;
          position: relative;
        }

        .aped-values-title::after {
          content: '';
          display: block;
          width: 50px;
          height: 3px;
          background-color: #b4a35e;
          margin: 0.75rem auto 0;
        }

        .aped-values-container {
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          overflow: hidden;
        }

        .aped-values-sidebar {
          display: flex;
          flex-wrap: wrap;
          background: #f0f0f0;
          padding: 0.5rem;
        }

        .aped-value-button {
          flex: 1 0 calc(50% - 0.5rem);
          display: flex;
          align-items: center;
          padding: 0.75rem;
          border: none;
          background: none;
          cursor: pointer;
          transition: background-color 0.3s;
          color: #333;
          text-align: left;
          margin: 0.25rem;
          border-radius: 4px;
        }

        .aped-value-button.active {
          background-color: #b4a35e;
          color: #fff;
        }

        .aped-value-icon {
          font-size: 1.25rem;
          margin-right: 0.5rem;
        }

        .aped-value-title {
          font-size: 0.9rem;
          font-weight: 500;
        }

        .aped-value-content {
          padding: 1.5rem;
        }

        .aped-value-content h3 {
          font-size: 1.25rem;
          color: #b4a35e;
          margin-bottom: 0.75rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .aped-value-content p {
          font-size: 0.95rem;
          line-height: 1.5;
          color: #34495e;
          margin-bottom: 1rem;
        }

        .aped-value-image {
          width: 100%;
          height: auto;
          border-radius: 8px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }

        @media (min-width: 768px) {
          .aped-values-section {
            padding: 4rem 2rem;
          }

          .aped-values-title {
            font-size: 2.5rem;
            margin-bottom: 2rem;
          }

          .aped-values-container {
            display: flex;
          }

          .aped-values-sidebar {
            width: 30%;
            flex-direction: column;
            padding: 1rem 0;
          }

          .aped-value-button {
            flex: none;
            width: calc(100% - 1rem);
          }

          .aped-value-content {
            width: 70%;
            padding: 2rem;
          }

          .aped-value-content h3 {
            font-size: 1.75rem;
          }

          .aped-value-content p {
            font-size: 1.1rem;
          }

          .aped-value-image {
            max-width: 400px;
            margin: 1rem auto 0;
          }
        }
      `}</style>
    </section>
  );
};

export default Services;
